module.exports = __webpack_public_path__ + "img/contract.b3c13c69.png";